const isValidSWIFT = value => /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value);

export default isValidSWIFT;
